import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ErrorResponse } from '../../models/error-response';
import * as moment from 'moment';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { AlertDialogComponent } from '../../../components/layout/alert-dialog/alert-dialog.component';

@Injectable()
export class DialogService {
  constructor(public translate: TranslateService, private _matDialog: MatDialog) { }

private showDialogOneButtonCallbackTitleHTML (inCallback: Function, inTitle: string, inBody: string, inOKButtonText: string) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.minHeight = '250px';
    dialogConfig.width = '600px';
    dialogConfig.data = {
        title: inTitle,
        message: inBody,
        buttonText: inOKButtonText
    };

    this._matDialog.open(AlertDialogComponent, dialogConfig).afterClosed().subscribe(
        _ => inCallback()
    );
  }

private showDialogOneButtonTitleHTML (inTitle: string, inBody: string, inButtonText: string) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.minHeight = '250px';
    dialogConfig.width = '600px';
    dialogConfig.data = {
        title: inTitle,
        message: inBody,
        buttonText: inButtonText
    };
    this._matDialog.open(AlertDialogComponent, dialogConfig);
  }
  showSuccessDialogWithCallback (inCallback: Function, inBody: string) {
    this.translate.get(['portal.General.Dialog.Success.Title', 'portal.General.Button.OK']).subscribe((res: string) => {
        const title = '<div><i class="fa fa-check-circle fa-2x text-success" aria-hidden="true"></i></div><h3>'
        + res['portal.General.Dialog.Success.Title'] + '</h3></div>';
        this.showDialogOneButtonCallbackTitleHTML(inCallback, title, inBody, res['portal.General.Button.OK']);
    });
  }

  showSuccessDialog (inBody: string) {
    this.translate.get(['portal.General.Dialog.Success.Title', 'portal.General.Button.OK']).subscribe((res: string) => {
        const title = '<div><i class="fa fa-check-circle fa-2x text-success" aria-hidden="true"></i></div><h3>'
          + res['portal.General.Dialog.Success.Title'] + '</h3></div>';
        this.showDialogOneButtonTitleHTML(title, inBody, res['portal.General.Button.OK']);
    });
  }

  showInfoDialog (inBody: string) {
    this.translate.get(['portal.General.Dialog.Info.Title', 'portal.General.Button.OK']).subscribe((res: string) => {
        const title = '<div><i class="fa fa-info-circle fa-2x text-info" aria-hidden="true"></i></div><h3>'
        + res['portal.General.Dialog.Info.Title' ] + '</h3></div>';
        this.showDialogOneButtonTitleHTML(title, inBody, res['portal.General.Button.OK']);
    });
  }

  showWarningDialog (inBody: string) {
    this.translate.get(['portal.General.Dialog.Warning.Title', 'portal.General.Button.OK']).subscribe((res: string) => {
        const title = '<div><i class="fa fa-exclamation-triangle fa-2x text-warning" aria-hidden="true"></i></div><h3>'
        + res['portal.General.Dialog.Warning.Title' ] + '</h3></div>';
        this.showDialogOneButtonTitleHTML(title, inBody, res['portal.General.Button.OK']);
    });
  }

  showErrorDialogWithBody (inBody: string) {
    this.translate.get(['portal.General.Dialog.Error.Title.Single', 'portal.General.Button.OK']).subscribe((res: string) => {
        const title = '<div><i class="fa fa-times-circle fa-2x text-danger" aria-hidden="true"></i></div><h3>'
        + res['portal.General.Dialog.Error.Title.Single'] + '</h3></div>';
        this.showDialogOneButtonTitleHTML(title, inBody, res['portal.General.Button.OK']);
    });
  }

  showErrorDialog (errors: ErrorResponse[]= []) {
    const translationIds = ['portal.General.Button.OK'];

    if (!errors || errors === undefined || errors.length <= 1) {
        translationIds.push('portal.General.Dialog.Error.Title.Single');
        translationIds.push('portal.General.Dialog.Error.Text.Single');
        translationIds.push('portal.General.Dialog.Error.Error.Default');
    } else {
        translationIds.push('portal.General.Dialog.Error.Title.Multi');
        translationIds.push('portal.General.Dialog.Error.Text.Multi');
    }
    if (errors && errors !== undefined) {
        for (const error of errors) {
            translationIds.push('portal.General.Dialog.Error.Error.' + error.textCode);
        }
    }

    this.translate.get(translationIds).subscribe((res: string) => {
        let title = '<div><i class="fa fa-times-circle fa-2x text-danger" aria-hidden="true"></i></div><h3>';
        let body = '';

        if (!errors || errors === undefined || errors.length <= 1) {
            title += res['portal.General.Dialog.Error.Title.Single' ];
            body = res['portal.General.Dialog.Error.Text.Single'];
        } else {
            title += res['portal.General.Dialog.Error.Title.Multi' ];
            body = res['portal.General.Dialog.Error.Text.Multi'];
        }
        title += '</h3></div>';
        body += '<ul>';
        if (!errors || errors === undefined || errors.length === 0) {
            body += '<li>' + res['portal.General.Dialog.Error.Error.Default'] + '</li>';
        } else {
            for (const error of errors) {
                body += '<li>';
                const message = res['portal.General.Dialog.Error.Error.' + error.textCode];
                if (message === ('portal.General.Dialog.Error.Error.' + error.textCode)) {
                    body += error.message;
                } else {
                    body += message;
                }
                if (error.errorId !== '') {
                    body += ' (ErrorId: ' + error.errorId + ')';
                }
                body += '</li>';
            }
        }
        body += '</ul>';
        this.showDialogOneButtonTitleHTML(title, body, res['portal.General.Button.OK']);
    });
  }
}
